export function useIsMobileWidth() {
    return useScssBreakpoints().smaller('lg')
}
